<ng-container *transloco="let t">
  <section *ngIf="hasSpecs" class="featured-specs-card">
    <span class="fixed-space-16" aria-hidden="true"></span>
    <section class="wrapper" [class.read-more]="readMore">
      <ul
        class="spec-list"
        [class.mobile]="(lessThan$ | async)?.sm"
        [class.short]="(lessThan$ | async)?.md">
        <li
          *ngFor="let spec of specList | keyvalue; trackBy: trackByKey"
          class="item flex popsy-card"
          [class.hide-field]="spec.key === 'model_numbers'">
          <span class="spec-key small">{{ t('spec_' + spec.key) }}:</span>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="spec-value small">{{ spec.value }}</span>
        </li>
        <li *ngIf="specList?.model_numbers" class="item flex popsy-card">
          <span class="spec-key small">{{ t('spec_model_numbers') }}:</span>
          <span class="spec-value small">{{ specList?.model_numbers || '' }}</span>
        </li>
      </ul>
    </section>
    <span class="fixed-space-16" aria-hidden="true"></span>
    <span class="expand" *ngIf="!readMore" (click)="readMore = !readMore">
      {{ t('label_show_more') }}
    </span>
    <span class="expand" *ngIf="readMore" (click)="collapseAndScroll()">
      {{ t('label_show_less') }}
    </span>
    <span class="fixed-space-16" aria-hidden="true"></span>
  </section>

  <section *ngIf="!hasSpecs" class="featured-specs-card">
    <span class="fixed-space-16" aria-hidden="true"></span>
    <pre class="wrapper">{{ t('msg_empty_description_long') }}</pre>
  </section>
</ng-container>
